import { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { HelpModal } from './HelpModal';
import { useClientData } from '../hooks/useClientData';

/**
 * Fixed floating help button at bottom right of the page
 * Opens the Help & Contact modal when clicked
 */
export function HelpButton() {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { clientData } = useClientData();

  return (
    <>
      <button
        onClick={() => setShowHelpModal(true)}
        className="w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center"
        aria-label="Open Help & Contact"
        title="Help & Contact"
      >
        <HelpCircle className="w-6 h-6" aria-hidden="true" />
      </button>

      <HelpModal
        isOpen={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        clientData={clientData}
      />
    </>
  );
}
